import { put, takeLeading } from 'redux-saga/effects';
import { getLearningObjectives } from '../crud/learningObjectives.crud';
import { REDUCER_LEARNING_OBJECTIVES } from './conf';

export const actionTypes = {
  GetLearningObjectives: 'cms/GET_LEARNING_OBJECTIVES',
  SetLearningObjectives: 'cms/SET_LEARNING_OBJECTIVES',
};

const initialState = {
  data: [],
  loading: false,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GetLearningObjectives:
      return { ...state, loading: true };

    case actionTypes.SetLearningObjectives: {
      const { response } = action.payload;
      if (response && response.status === 'success' && response.data) {
        return { data: response.data, loading: false };
      }
      return { ...state, loading: false };
    }

    default:
      return state;
  }
};

export const selectors = {
  getLearningObjectives: (state) => {
    return state.entities[REDUCER_LEARNING_OBJECTIVES].data;
  },
};

export const actions = {
  getLearningObjectives: (params) => ({ type: actionTypes.GetLearningObjectives, payload: { params } }),
  fulfillLearningObjectives: (response) => ({ type: actionTypes.SetLearningObjectives, payload: { response } }),
};

export function* saga() {
  yield takeLeading(actionTypes.GetLearningObjectives, function* getLearningObjectivesSaga(action) {
    try {
      const { data } = yield getLearningObjectives(action.payload.params);
      yield put(actions.fulfillLearningObjectives(data));
    } catch {
      yield put(actions.fulfillLearningObjectives(null));
    }
  });
}
